export const enumPermisosCajaSocial = Object.freeze({
  DEPOSITO_CAJA_SOCIAL: 37000,
  PAGO_PRODUTOS_PROPIOS_CAJA_SOCIAL: 37001,
  RECAUDO_SERVICIOS_PUBLICOS_CAJA_SOCIAL: 37002,
  PAGO_PILA_CAJA_SOCIAL: 37003,
  RETIRO_OTP_CAJA_SOCIAL: 37004,
});
